(function (fox, $) {
	"use strict";

	fox.registerWidget('NotificationViewer', {
		currentCollection: {},

		configure: function(options) {
			this.desktopLimit = 10;
			this.mobileLimit = 3;

			this.registerOptions('', {
				updateTime: 60000,
				widgets: {
					notificationListData: {
						widget: 'Datalayer',
						method: 'Activity_Notification.get',
						transitParameters: {
							notifyFrom: this.getNotifyCookie()
						},
						limit: this.getLimit(),
						'handleWom.loadDl': {
							event: 'loaded',
							widget: '@this',
							callback: '@parent:_setNotifyCookie'
						}
					}
				},

				handleDom: {
					clickToDel: {
						targetWidget: '#notificationGrid #list',
						event: 'click',
						target: '.delete',
						callback: 'submitDelete'
					}
				},
				handleWom: {
					socketInbox: {
						widget: '@root #socket',
						event: 'inboxSocketEventActivity:notification',
						callback: (resp) => {
							const externalHandler = this.getOption('externalHandler');

							if (fox.isFunction(externalHandler)) {
								const message = resp.answer;
								const result = externalHandler(message);

								return result && this._handleSocketMessage(resp);
							}

							return this._handleSocketMessage(resp);
						}
					},
					socketConnection: {
						widget: '@root #socket',
						event: ['socketReady', 'socketDisconnected'],
						callback: '_handleSocketConnection'
					}
				}
			});

			if (!this.notificationsIsDisabled()) {
				this.registerOptions('', {
					handleWom: {
						socketInbox: {
							widget: '@root #socket',
							event: 'inboxSocketEventActivity:notification',
							callback: '_handleSocketMessage'
						},
						socketConnection: {
							widget: '@root #socket',
							event: ['socketReady', 'socketDisconnected'],
							callback: '_handleSocketConnection'
						}
					}
				});
			}

			this.callParent('configure', arguments);
		},

		init: function() {
			this.callParent('init', arguments);
			
			if (fox.cookie.get('disableNotifying') || this.notificationsIsDisabled()) {
				return;
			}

			this.embedWidget('notificationGrid', 'Grid', {
				dataLayer: '@parent #notificationListData',
				template: 'notificationBlock',
				container: '#notificationList',
				externalLoad: true,
				list: {
					autoRender: true,
					container: '#notifications',
					'tpl.row': 'notification_row'
				}
			});
		},

		running: function (argument) {
			if (this.notificationsIsDisabled() || this.isPreviewMode())
				return;

			this.startPolling();

			this.callParent('running', arguments);
		},

		isPreviewMode: function() {
			return fox.site.getOption('previewMode') === 1;
		},

		notificationsIsDisabled: function() {
			return this.isPreviewMode() || fox.site.getEnv('siteProps.onSiteNotificationsDisabled') === '1';
		},

		submitDelete: function(elem, alias, scope, event) {
			var currentRow = $(elem).parents('.notify');
			var id = currentRow.find('.notif_id').val();
			this.deleteRow(id);
			return false;
		},

		deleteAll: function () {
			var
				timer = 1000,
				c = fox.toArray(this.currentCollection)
			;

			fox.each(c, function (item, i) {
				if (i === 0) {
					this.deleteRow(item.id);
				} else {
					setTimeout(fox.bind(function () {
						this.deleteRow(item.id);
					}, this), timer);

					timer *= 2;
				}
			}, this);
		},

		deleteRow: function(id) {
			delete this.currentCollection[id];
			this.hookWrapper('deleteItem', id);
		},

		deleteItem: function (id) {
			$('input[value="'+ id +'"]').parent('.notify').animate({ height: "hide" }, 1000);
		},

		getNotifyCookie: function() {
			return fox.cookie.get('notifyFrom');
		},

		_setNotifyCookie: function(obj, w, e) {
			this.currentCollection = w.getCollection();
			var _collection = fox.toArray(this.currentCollection);

			if (!fox.isEmpty(_collection)) {
				fox.cookie.set('notifyFrom', _collection.pop().id);
			}
		},

		isTouchDevice: function () {
			//from Swipe.js library
			return ('ontouchstart' in window) || typeof window.DocumentTouch !== 'undefined' && document instanceof DocumentTouch;
		},

		getLimit: function () {
			return this.isTouchDevice() ? this.mobileLimit : this.desktopLimit;
		},

		_handleSocketMessage: function (response) {
			var msg = response.answer;
			var dl = this.wom1('#notificationListData');
			var id = msg.id;

			if (!this.currentCollection[id]) {
				this.currentCollection[id] = msg;
			}

			dl.setCollection(this.currentCollection);

			dl.dispatchEvent('loaded');
		},

		_handleSocketConnection: function (obj, socket, e) {
			if (e === 'socketReady') {
				this.stopPolling();

				return;
			}

			this.startPolling();
		},

		getNotifications: function (argument) {
			this.wom1('#notificationListData').load();
		},

		startPolling: function () {
			this.stopPolling();

			this.timer = window.setInterval(fox.bind(this.getNotifications, this), this.getOption('updateTime'));
		},

		stopPolling: function (argument) {
			if (this.timer) {
				window.clearInterval(this.timer);
				this.timer = null;
			}
		}

	}, 'Controller');

})(fox, fox.jQuery);



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/notification/notificationViewer.es.js